import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { cn } from '@/lib/cn'

export interface EmptyStateProps {
  icon?: LucideIcon
  /** What this surface is for. */
  title: string
  /** What fills it. Where nothing is wrong, say so plainly. */
  description?: string
  action?: ReactNode
  className?: string
}

/** Empty states explain what the surface is for and offer the action that
 *  fills it: "No quotes yet — quotes you create appear here with their margin
 *  and status." Where nothing is wrong, say so plainly: "Застрявших работ нет."
 *  Never apologise, never encourage. */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 px-6 py-10 text-center',
        className,
      )}
    >
      {Icon ? <Icon size={20} className="text-text-faint" aria-hidden /> : null}
      <p className="text-text-heading text-[13.5px] font-normal">{title}</p>
      {description ? (
        <p className="text-text-muted max-w-[42ch] text-[12.5px] leading-snug font-light">
          {description}
        </p>
      ) : null}
      {action ? <div className="mt-1">{action}</div> : null}
    </div>
  )
}
